import { ICameraRotation } from "../components/extensions/cameraExtension";
import { IVector } from "../interfaces";

export class CameraUtils {
	public static rotate(viewer: Autodesk.Viewing.GuiViewer3D, degrees: number): void {
		const camera = viewer.navigation.getCamera();
		const quaternion = new THREE.Quaternion();
		const vector = new THREE.Vector3();

		const view = vector.copy(camera.position).sub(camera.target).normalize();
		const radians = degrees * (Math.PI / 180);
		quaternion.setFromAxisAngle(view, radians);

		const up = viewer.navigation.getWorldUpVector();
		up.applyQuaternion(quaternion);

		viewer.navigation.setCameraUpVector(up);
	}

	public static getRotation(viewer: Autodesk.Viewing.GuiViewer3D): ICameraRotation {
		const camera = viewer.navigation.getCamera();

		return {
			quaternion: camera.quaternion,
		};
	}

	public static getScaleFactor(cameraPosition: THREE.Vector3, initialCameraPosition: IVector | undefined): number {
		const initialZ = initialCameraPosition?.z ?? 300;
		const z = cameraPosition.z;
		const scaleFactor = initialZ / z;

		return scaleFactor;
	}

	public static getCurrentZoomPercentage(cameraPosition: THREE.Vector3, initialCameraPosition: IVector | undefined): number {
		const initialZ = initialCameraPosition?.z ?? 300;

		const zoomPercentage = (initialZ / cameraPosition.z) * 100; // No-zoom = 100 More zoom = 200

		return zoomPercentage;
	}
}
